import { Drawer, Grid, Select, TextInput } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import type { UseFormReturnType } from '@mantine/form';
import { tKeys, tKeysLoose } from 'locales/index';
import { useTranslation } from 'locales/logic';
import { AI_CALL_END_REASONS, AI_CALL_OUTCOMES } from 'types/index';

import type { AiCallsFilter } from '../pages';

interface FilterDrawerProps {
  isOpen: boolean;
  close: () => void;
  form: UseFormReturnType<AiCallsFilter>;
}

export const FilterDrawer = ({ isOpen, close, form }: FilterDrawerProps) => {
  const { t } = useTranslation();

  const outcomeOptions = AI_CALL_OUTCOMES.map(value => ({
    value,
    label: t(tKeysLoose.AI_CALLS.FILTER_DRAWER.OUTCOME_OPTIONS[value.toUpperCase()]),
  }));

  const endReasonOptions = AI_CALL_END_REASONS.map(value => ({
    value,
    label: t(tKeysLoose.AI_CALLS.FILTER_DRAWER.END_REASON_OPTIONS[value.toUpperCase()]),
  }));

  return (
    <Drawer
      position="right"
      opened={isOpen}
      onClose={close}
      title={t(tKeys.AI_CALLS.FILTER_DRAWER.TITLE)}
    >
      <Grid>
        <Grid.Col span={12}>
          <TextInput
            label={t(tKeys.AI_CALLS.FILTER_DRAWER.INVOICE_REFERENCE)}
            placeholder={t(tKeys.AI_CALLS.FILTER_DRAWER.INVOICE_REFERENCE_PLACEHOLDER)}
            {...form.getInputProps('invoiceReference')}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label={t(tKeys.AI_CALLS.FILTER_DRAWER.DEBTOR_NAME)}
            placeholder={t(tKeys.AI_CALLS.FILTER_DRAWER.DEBTOR_NAME_PLACEHOLDER)}
            {...form.getInputProps('debtorName')}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <DatePickerInput
            label={t(tKeys.AI_CALLS.FILTER_DRAWER.START_DATE)}
            placeholder={t(tKeys.AI_CALLS.FILTER_DRAWER.START_DATE_PLACEHOLDER)}
            allowDeselect
            clearable
            {...form.getInputProps('startDate')}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <DatePickerInput
            label={t(tKeys.AI_CALLS.FILTER_DRAWER.END_DATE)}
            placeholder={t(tKeys.AI_CALLS.FILTER_DRAWER.END_DATE_PLACEHOLDER)}
            allowDeselect
            clearable
            {...form.getInputProps('endDate')}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Select
            label={t(tKeys.AI_CALLS.FILTER_DRAWER.OUTCOME)}
            placeholder={t(tKeys.AI_CALLS.FILTER_DRAWER.OUTCOME_PLACEHOLDER)}
            data={outcomeOptions}
            clearable
            searchable
            {...form.getInputProps('outcome')}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Select
            label={t(tKeys.AI_CALLS.FILTER_DRAWER.END_REASON)}
            placeholder={t(tKeys.AI_CALLS.FILTER_DRAWER.END_REASON_PLACEHOLDER)}
            data={endReasonOptions}
            clearable
            searchable
            {...form.getInputProps('endReason')}
          />
        </Grid.Col>
      </Grid>
    </Drawer>
  );
};
